import { createFileRoute, Outlet } from '@tanstack/react-router';

import { AppLayout } from '../../components/layout/AppLayout';

export const Route = createFileRoute('/init-console')({
	component: InitConsoleLayout,
});

function InitConsoleLayout() {
	return (
		<AppLayout restrictScroll={false}>
			<Outlet />
		</AppLayout>
	);
}
